import { createStore, applyMiddleware } from 'redux';
import rootReducer from '../reducers/rootReducer';
import { composeWithDevTools } from '@redux-devtools/extension';
import thunk from 'redux-thunk';
import { createBrowserHistory } from 'history';
import { verifyAuth } from '../components/auth/authActions';
import reduxReset from 'redux-reset';
export const history = createBrowserHistory();

let store;

export default function configureStore() {
  // Modern Redux DevTools configuration
  const enhancers = composeWithDevTools({
    name: 'DSZ Retailer Portal', // Name shown in DevTools
    trace: process.env.NODE_ENV === 'development', // Enable trace in development
    traceLimit: 25, // Limit trace to 25 actions
    maxAge: 50, // Maximum number of actions to store
    serialize: true, // Serialize complex objects
    actionSanitizer: (action) => ({
      ...action,
      // Remove sensitive data from actions if needed
      type: action.type
    }),
    stateSanitizer: (state) => {
      // Remove sensitive data from state if needed
      const { ...sanitizedState } = state;
      return {
        ...sanitizedState
      };
    }
  })(applyMiddleware(thunk), reduxReset());

  store = createStore(rootReducer(history), enhancers);

  store.dispatch({
    type: 'RESET'
  });
  store.dispatch(verifyAuth());

  //store.subscribe(() => saveToLocalStorage(store.getState()));

  return store;
}

export function getStore() {
  return store;
}

/* function saveToLocalStorage(state) {
  try {
    const serializedState = JSON.stringify(
      state.productCatalogue.productToImport
    );
    localStorage.setItem('selectedProduct', serializedState);
  } catch (e) {
    console.log(e);
  }
}
 */
